<template>
  <li class="lstCheckout__item">
    <div class="mask" v-if="showMask" @click="hideAllModals"></div>
    <div class="header cf">
      <p class="txt blue"><strong>Etiqueta {{ index + 1 }}:</strong></p>
      <img class="logo" :src="self.service.company.picture" :alt="self.service.company.name" :title="self.service.company.name">
      <div v-if="isCorreiosPPN" class="tag tag--primary">
        <strong>MODALIDADE:</strong> Logística Reversa
      </div>

      <template v-else>
        <p class="txt"><strong>Modalidade:</strong> {{ self.service.name }}</p>
        <p class="txt"><strong>Código de envio:</strong> {{ self.protocol }}</p>
      </template>
      <p class="txt" v-if="self.agency"><strong>Agência:</strong> {{ self.agency.name }}</p>

      <button
        v-if="shouldDisplayPrintButton"
        class="btnBorder btnBorder--small btnBorder--blue btnBorder--ico -ico-right"
        @click="$parent.checkPrint(index)"
      >
        <span>{{ checkPrintButtonLabel }}</span>

        <ion-icon v-if="isCorreiosPPN" name="receipt-outline" class="ico" />
        <svg v-else class="ico"><use xlink:href="/images/svg-symbols.svg#print"></use></svg>
      </button>
    </div>
    <div class="package">
      <ul class="packageList">
        <li class="packageList__item">
          <strong class="ttl">Volumes</strong>
          <div class="content">
            <p><strong>Dimensões:</strong></p>
            <div v-for="(item, volKey) in groupVolumes.slice(0,3)" :key="volKey">
              <p>
                <span v-show="groupVolumes.length > 1">{{transformNumberToAlphabet(volKey)}}| </span>{{ item.times }} Qtd. x
                {{ item.height }}cm A X
                {{ item.width }}cm L X
                {{ item.length }}cm C X
                {{ item.weight }}Kg
              </p>
            </div>
            <div v-if="groupVolumes.length > 3">
              <a href="javascript:;" class="editDeclaracao__link" @click="$refs['modalV2ViewVolumes'].open()">Ver volumes</a>
            </div>
            <p><strong>Valor Segurado:</strong> {{ self.insurance_value | currency }}</p>
            <p><strong title="Aviso de recebimento">A.R.:</strong> {{ self.receipt | prettyBool }}</p>
            <p><strong>Mão Própria:</strong> {{ self.own_hand | prettyBool }}</p>
            <p><strong>Coleta:</strong> {{ self.collect | prettyBool }}</p>
            <p v-if="self.tags && self.tags.length"><strong>Tags:</strong> {{ self.tags.map((e) => e.tag).join(', ') }}</p>
          </div>
        </li>
        <li class="packageList__item">
          <strong class="ttl">Prazo</strong>
          <div class="content">
            <p>{{ delivery }}</p>
          </div>
        </li>
        <li class="packageList__item">
          <strong class="ttl">Remetente</strong>
          <div class="content">
            <p>{{ self.from.name }}</p>
            <p>CEP: {{ self.from.postal_code | postal_code }}</p>
            <p>Endereço: {{ self.from.address }}, {{ self.from.location_number }}<template v-if="self.from.complement"> {{ self.from.complement }}</template></p>
            <p>{{ self.from.district }} - {{ self.from.city }}/{{ self.from.state_abbr }}</p>
          </div>
        </li>
        <li class="packageList__item">
          <strong class="ttl">Destinatário</strong>
          <div class="content">
            <p>{{ self.to.name }}</p>
            <p v-if="self.to.email" class="break-word">E-mail: {{ self.to.email }}</p>
            <p>CEP: {{ self.to.postal_code | postal_code }}</p>
            <p>Endereço: {{ self.to.address }}, {{ self.to.location_number }}<template v-if="self.to.complement"> {{ self.to.complement }}</template></p>
            <p>{{ self.to.district }} - {{ self.to.city }}/{{ self.to.state_abbr }}</p>
          </div>
        </li>
        <li class="packageList__item">
          <strong class="ttl">Preço</strong>
          <div class="content">
            <p v-if="self.coupon" class="price">{{ price_without_coupon | currency }}</p>

            <p v-if="self.coupon" class="price price--red price--negative">{{ coupon_value }}</p>

            <p class="price price--blue">{{ self.price | currency }}</p>
          </div>
        </li>
      </ul>
    </div>

    <transition name="fade">
      <VolumesModal ref="modalV2ViewVolumes" :volumes="groupVolumes" />
    </transition>
  </li>
</template>

<script>
  import Alphabet from 'commons/js/Alphabet';

  import VolumesModal from 'commons/js/components/modals/VolumesModal';

  export default {
    components : {
      VolumesModal
    },

    props : {
      index: {
        type: Number,
        required: true
      },
    },

    data() {
      return {
         modalViewVolumes: false,
         showMask: false,
      }
    },

    computed: {
      self: function () {
        return this.$parent.purchase.orders[this.index];
      },
      price_without_coupon: function () {
        if (!this.self.coupon) {
          return this.self.price;
        }

        if (this.self.coupon.percent) {
          return Math.max(Math.round((this.self.price /  (1 - this.self.coupon.value / 100)) * 100) / 100, 0);
        }

        return Math.max(Math.round((this.self.price + this.self.coupon.value) * 100) / 100, 0);
      },
      delivery() {
        if (!this.self) return '-';

        return `${this.self.delivery_min} ${this.self.delivery_min > 1 ? `dias úteis` : `dia útil`} a partir da data de postagem`;
      },
      coupon_value: function () {
        if (!this.self.coupon) {
          return 'R$ 0,00';
        }

        if (this.self.coupon.percent) {
          return this.self.coupon.value + '%';
        }

        return 'R$ ' + Number(this.self.coupon.value).toLocaleString('pt-BR', {
          currency: 'BRL',
          minimumFractionDigits: 2
        });
      },
       groupVolumes: function() {
        const volumesGroup = this.self.volumes.reduce((a, b) => {
          const i = a.findIndex(x => x.height === b.height && x.length === b.length && x.weight === b.weight && x.width === b.width);
          return i === -1 ? a.push({
            ...b,
            times: 1
          }) : a[i].times++, a;
        }, []);
        return volumesGroup;
      },

      isCorreiosPPN() {
        return this.self.is_show_correios_reverse_ppn_action;
      },

      checkPrintButtonLabel() {
        return this.isCorreiosPPN ? 'Gerar Código' : 'Imprimir';
      },

      shouldDisplayPrintButton() {
        if (this.self.authorization_code) return false;
      },
    },

    filters: {
      postal_code(value) {
        return leftPad(String(value).replace(/\D/g, ''))
          .replace(/^(\d{5})(\d{3})$/, '$1-$2');
        function leftPad(value, length = 8, chr = '0') {
          while (value.length < length) {
            value = chr + value;
          }
          return value;
        }
      },
      currency(value, currency = 'R$', hasZero = true) {
        value = String(value);
        let matches = value.match(/(\,|\.)(\d{2})$/);
        if (matches && matches.length >= 3) {
          value = value.substr(0, value.length - 3).replace(/\D/g, '') + '.' + matches[2];
        }
        value = parseFloat(value);
        if (!(value && !isNaN(value) && isFinite(value))) value = 0;
        if (!hasZero && !value) return '-';
        return currency + ' ' + Number(value).toLocaleString('pt-BR', {
          currency: 'BRL',
          minimumFractionDigits: 2
        });
      },
      decimal(value) {
        if (!(value && !isNaN(value) && isFinite(value))) value = 0;
        return Number(value).toLocaleString();
      },
      prettyBool(value) {
        return Boolean(Number(value)) ? 'Sim' : 'Não';
      },
    },

    methods: {
      showModal(modal) {
        this[modal] = true;
        this.showMask = true;
        if (scroll) {
          this.modalHeight = window.innerHeight - 210;
        }
      },
      hideModal(modal) {
        this[modal] = false;
        this.showMask = false;
      },
       hideAllModals() {
        this.showMask = false;
        this.modalViewVolumes = false;
      },
      transformNumberToAlphabet(number) {
        return Alphabet(number);
      }
    }
  }
</script>
